import React from 'react';
import { useSiteData } from 'react-static';
import { directCall } from '@nmx/utils-frontend/dist/utilities/frontend/Analytics/dtm_helper';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import LoginForm from '@nmx/template/dist/componentLibrary/modules/forms/Login';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

import {
  ListStyled,
  TypographyStyled,
} from './styles';

export default () => {
  const { config } = useSiteData();
  // Function to handle legacy directCall for analytics.
  const handleAnchorClick = (e) => {
    const target = e.target || e.srcElement;
    let loginText;

    if (target) {
      loginText = target.getAttribute('data-tracking-id');
    } else {
      loginText = 'No Target Element Defined';
    }

    const dataElements = { 'tracking-id': loginText };

    directCall('log-in-click', dataElements);
  };

  return (
    <SectionContainer
      id='log-in'
      backgroundVariant='lightA'
      themeType='lightTheme'>
      <Row align='center'>
        <Col
          medium={8}
          align='center'>
          <TypographyStyled
            component='h1'>
            Log in to your account
          </TypographyStyled>
        </Col>
      </Row>
      <Row align='center'>
        <Col
          medium={6}
          small={10}>
          <LoginForm
            config={config}
            formIdSuffix='login-page' />
        </Col>
      </Row>
      <Row>
        <Col align='center'>
          <Typography disableBottomPadding>
            Log in to other Northwestern <WidowBlock>Mutual sites.</WidowBlock>
          </Typography>
          <ListStyled reduced>
            <li className='link-list__item'>
              <Link
                ariaLabel='Visit Northwestern Access Fund.'
                data-tracking-id='nm-access-fund'
                isOutgoingLink
                linkUrl='https://www.eaccountservices.com/NM/'
                onClick={handleAnchorClick}
                variant='primaryDeemphasize'>
                Access Fund
              </Link>
            </li>
            <li className='link-list__item'>
              <Link
                ariaLabel='Visit Northwestern Mutual Business Insurance.'
                data-tracking-id='business-insurance'
                isOutgoingLink
                linkUrl='https://bcis.northwesternmutual.com/bcis/update/login/'
                onClick={handleAnchorClick}
                variant='primaryDeemphasize'>
                Business Insurance
              </Link>
            </li>
            <li className='link-list__item'>
              <Link
                ariaLabel='Visit Northwestern Mutual Brokerage and Advisory.'
                data-tracking-id='brokerage-and-advisory'
                isOutgoingLink
                linkUrl='https://nmis.netxinvestor.com/'
                onClick={handleAnchorClick}
                variant='primaryDeemphasize'>
                Brokerage and Advisory
              </Link>
            </li>
          </ListStyled>
        </Col>
      </Row>
    </SectionContainer>
  );
};
